import { connect } from 'react-redux';

import { push } from 'react-router-redux';
import Actions from '../../actions';

import AddressFields from '../../components/checkout-steps/address/address-fields';
import CountryAPI from '../../apis/country';
import APP_ROUTES from '../../constants/app-routes';

const mapStateToProps = (state, ownProps) => ({
    locale: state.locale,
    displayLoader: state.displayLoader,
    billingCountries: state.countryList.shippingCountries,
    shippingCountries: state.countryList.billingCountries,
    municipalityInfo: state.order.municipalityInfo,
    availableMunicipalities: state.municipalities.availableMunicipalities,
});

const mapDispatchToProps = (dispatch) => ({

    fetchStatesForCountry: (selectedCountryIso, availableName, currentZone) => CountryAPI.getStatesByCountry({ countryId: selectedCountryIso, availableName, currentZone })
        .then((response) => response.body, () => ({ states: [] })),

    fetchCountries: (availableName, zoneId) => CountryAPI.getCountryList({ availableName, zoneId }).then(
        (response) => {
            // Sort countries alphabetically
            const countries = response.body.countries.sort((a, b) => {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
                return 0;
            });

            if (availableName === 'available_for_billing_true') {
                dispatch(Actions.addBillingCountries(countries));
            } else {
                dispatch(Actions.addShippingCountries(countries));
            }
        },
        (error) => {
            console.log(error);

            // TODO: Show message
            // dispatch(Actions.showFlash('Unable to connect to server... Please try again later.'));
        },
    ),

    fetchMunicipalitiesForCountryState: (selectedCountryIso, selectedState) => CountryAPI.getMunicipalityList({ countryId: selectedCountryIso, stateCode: selectedState })
        .then((response) => response.body, () => ({ municipalities: [] })),

    setCurrentMunicipality: (municipalityId) => dispatch(Actions.setCurrentMunicipality(municipalityId)),

    emptyCurrentCart: () => dispatch(Actions.emptyCurrentCart()),

    goToHome: () => dispatch(push(APP_ROUTES.homePageRoute)),
});

const AddressFieldsConnector = connect(mapStateToProps, mapDispatchToProps)(AddressFields);

export default AddressFieldsConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/checkout-steps/address-fields-connector.js
 **/